import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES, BONOS, PRODUCT_NAME, PAYMENT_TEXT } from './salesData';
import { BUNDLE_IMAGE_URL } from '../utils/headMeta';
export function OfferSection() {
  return <section id="comprar" className="bg-sand pb-16 pt-12 sm:py-16" data-id="element-166" data-mp="dfg8z0hjpqab">
      <div className="mx-auto max-w-5xl px-5" data-id="element-167" data-mp="ic6pfox9inw9">
        <div className="text-center" data-id="element-168" data-mp="ifkr0uy3qt2n">
          <SectionTag className="bg-white" data-id="element-169" data-mp="me219nctkjoa">Todo lo que recibís</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[20ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[28ch] sm:text-[2.3rem]" data-id="element-170" data-mp="rdwo9fth4p42">
            Los 6 tomos y los 4 bonos, en un <span className="mark-yellow" data-id="element-171" data-mp="2t5ja72yidtto">solo pago</span>.
          </h2>
        </div>

        <div className="mt-7 overflow-hidden rounded-[2rem] border border-stone bg-white shadow-[0_40px_80px_-50px_rgba(25,23,19,0.5)]" data-id="element-172" data-mp="2y4cq1219pwx0">
          <div className="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]" data-id="element-173" data-mp="12ojyeim8ueox">
            <div className="flex items-center justify-center bg-cream px-5 py-7 sm:p-10" data-id="element-174" data-mp="xwa2mlyg6keq">
              <img src={BUNDLE_IMAGE_URL} alt="Los 6 tomos de la colección 500+ Recetas Keto + Sin TACC" loading="lazy" decoding="async" width={1209} height={1298} className="h-auto w-full max-w-[320px] object-contain drop-shadow-[0_26px_34px_rgba(25,23,19,0.18)] sm:max-w-[420px]" data-id="element-175" data-mp="sxfjtk0hcvum" />
            </div>

            <div className="p-6 sm:p-9" data-id="element-176" data-mp="1ckn0xpl0cfce">
              <p className="font-display text-[1.3rem] font-extrabold uppercase leading-tight tracking-tight text-charcoal sm:text-[1.7rem]" data-id="element-177" data-mp="1cnspn3pq5f7l">
                {PRODUCT_NAME}
              </p>

              <p className="mt-4 font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-178" data-mp="17u8sdob1ovt">
                La colección
              </p>
              <ul className="mt-2.5 space-y-1.5" data-id="element-179" data-mp="3tv15wl6fzf9m">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.85rem] leading-snug text-charcoal/85" data-id="element-180" data-mp="2mnajst8xz7r">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-coral" aria-hidden strokeWidth={3} data-id="element-181" data-mp="3oudevzi7qyfe" />
                    {item}
                  </li>)}
              </ul>

              <p className="mt-5 font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-182" data-mp="315c2k169f34u">
                + Los 4 bonos de regalo
              </p>
              <ul className="mt-2.5 space-y-1.5" data-id="element-183" data-mp="364oqkp8vag90">
                {BONOS.map(bono => <li key={bono.num} className="flex gap-2.5 font-sans text-[0.85rem] font-medium leading-snug text-charcoal/85" data-id="element-184" data-mp="2s5fjcf2n2wh6">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-coral" aria-hidden strokeWidth={3} data-id="element-185" data-mp="2digtupncec53" />
                    <span data-id="element-186" data-mp="2mjeo4g7zb5ah">
                      Bono {bono.num}: {bono.name}{' '}
                      <span className="text-taupe" data-id="element-187" data-mp="2ifyt1obk5czw">· incluido sin costo adicional</span>
                    </span>
                  </li>)}
              </ul>

              <PriceBlock className="mt-7" size="lg" data-id="element-188" data-mp="2rhznkdfepkxv" />

              <div className="mt-5 flex justify-center" data-id="element-189" data-mp="2rhg7715en4ly">
                <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-190" data-mp="366vug75q8rww" />
              </div>

              <p className="mt-3.5 text-center font-sans text-[0.76rem] font-semibold text-taupe" data-id="element-191" data-mp="316zqg7x150hc">
                Compra única · Acceso digital inmediato
              </p>
              <p className="mx-auto mt-1.5 max-w-[40ch] text-center font-sans text-[0.72rem] leading-snug text-taupe" data-id="element-192" data-mp="3f4y1p4g20gsm">
                🔒 {PAYMENT_TEXT}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}